import { BaseComponent, StoryblokImage } from '@cinch-nx/data-storyblok'
import { OfferCard as SharedOfferCard } from '@cinch-nx/shared-ui'

interface OfferCardProps extends BaseComponent {
  component: 'OfferCard'
  image: StoryblokImage
  banner: string
  title: string
  offerDetail1: string
  offerDetail2: string
  offerDetail3: string
  offerDetail4: string
  footerText: string
}

export const OfferCard = ({
  _uid,
  component,
  image,
  banner,
  title,
  offerDetail1,
  offerDetail2,
  offerDetail3,
  offerDetail4,
  footerText,
}: OfferCardProps) => (
  <SharedOfferCard
    _uid={_uid}
    component={component}
    imageSrc={image.filename}
    banner={banner}
    title={title}
    offerDetails={[offerDetail1, offerDetail2, offerDetail3, offerDetail4]}
    footerText={footerText}
  />
)
